
import settings from '../../settings.json';

export default {
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
    PREDICTRANGES: () => {
      return settings.predict_ranges;
    }
  }
}